module.exports = __webpack_public_path__ + "img/honda-logo.a8846360.jpg";